import { AfterViewInit, Component, ElementRef, HostListener, Input, OnDestroy, ViewChild, ChangeDetectionStrategy } from '@angular/core';

import { each } from 'lodash';

import { Enums } from '../../../../../../../configs/Enums';
import { TICKETS_PATHS } from '../../../../../../tickets/tickets';
import { WorkShiftService } from '../../../../../work-shift.service';
import { TicketViewService } from '../../../../../../tickets/ticket-view/ticket-view.service';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-tickets-list-new',
  templateUrl: './tickets-list.component.html',
  styleUrls: ['./tickets-list.component.scss'],
  standalone: false,
})
export class TicketsListComponent implements AfterViewInit, OnDestroy {
  destroyer = new Subject<void>();
  public Enums = Enums;
  public moment = require('moment');
  public TICKETS_PATHS = TICKETS_PATHS;
  public dateShortFormat = Enums.dates.shortFormat;
  public currentDate = this.moment().startOf('day').format(this.dateShortFormat);
  public isOpenTicketsBrigadeAssignPopover: boolean;
  public ticketBrigadePopoverOpen: any;
  public listHeight = 0;
  public waitFor = true;
  public refreshingTicketIds: Set<number> = new Set();
  @Input() ticketsCurrentFilter;
  @Input() ticketsPeriodFilter;
  @Input() ticketsMultipleAssign;
  @Input() tickets;
  @Input() filter;
  @Input() brigadeAssign;

  @ViewChild('ticketsList') ticketsListEl;
  @ViewChild('wrapperHeader') wrapperHeader: ElementRef;
  @ViewChild('ticketsListHeader')
  ticketsListHeader: ElementRef;

  @HostListener('window:resize')
  onResize() {
    this.checkListHeight();
  }

  constructor(
    private workShiftService: WorkShiftService,
    private ticketViewService: TicketViewService
  ) {}

  ngAfterViewInit() {
    this.checkListHeight();
    this.workShiftService.filterCollapse$.pipe(debounceTime(500), takeUntil(this.destroyer)).subscribe(() => {
      this.checkListHeight();
    });
  }

  public checkListHeight() {
    if (this.ticketsListEl && this.ticketsListEl.nativeElement) {
      const rect = this.ticketsListEl.nativeElement.getBoundingClientRect();
      this.listHeight = Math.min(document.documentElement.clientHeight - rect.top - 70, 500);
    }

    return this.listHeight;
  }

  public changeStateOpened(district): void {
    Object.defineProperty(district, 'isOpened', {
      value: !district.isOpened,
    });
  }

  public onOpenTicketBrigadeAssignPopover(state): void {
    this.isOpenTicketsBrigadeAssignPopover = state.state;
    this.ticketBrigadePopoverOpen = state.ticket;
  }

  ngOnDestroy() {
    this.destroyer.next();
    this.destroyer = null;
  }

  refreshLineStatus(ticket: any, event?: Event): void {
    if (event) {
      event.stopPropagation();
    }
    if (!ticket || !ticket.id || this.refreshingTicketIds.has(ticket.id)) {
      return;
    }
    this.refreshingTicketIds.add(ticket.id);
    this.ticketViewService.getHdAbonentStatus({
      login: ticket.ticket_login || '',
    }).subscribe(
      (response: any) => {
        this.refreshingTicketIds.delete(ticket.id);
        if (response.data && response.data.status != null) {
          const code = Number(response.data.status);
          ticket.hd_line_status_info = [1, 2, 3, 4].indexOf(code) > -1 ? 1 : 0;
        } else {
          ticket.hd_line_status_info = null;
        }
      },
      () => {
        this.refreshingTicketIds.delete(ticket.id);
      }
    );
  }
}
